import { render, staticRenderFns } from "./campaign-metrics.vue?vue&type=template&id=8ce8fd5a&scoped=true"
import script from "./campaign-metrics.vue?vue&type=script&lang=js"
export * from "./campaign-metrics.vue?vue&type=script&lang=js"
import style0 from "./campaign-metrics.vue?vue&type=style&index=0&id=8ce8fd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce8fd5a",
  null
  
)

export default component.exports